module.exports = __webpack_public_path__ + "media/images/about-us/Top Left - Woods-e4ac5fa19d36804122bf7ce825ccf678.jpeg";